import React from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import PageContent from '../components/PageContent';
import JoinUs from '../components/JoinUs';
import Events from '../components/Events';
import Impact from '../components/Impact';
import Testimonials from '../components/Testimonials';
import TechStats from '../components/TechStats';

const Home = () => {
    return (
        <div>
        
        <Header />
        <PageContent />
        <Events />
        <Impact />
        <Testimonials />
        <JoinUs />
        
        <Footer/>
     
        </div>
    );
};

export default Home;